import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMigrate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 6.89949C9.09818 6.32928 8.034 6 6.89427 6C3.63896 6 1 8.68629 1 12C1 15.3137 3.63896 18 6.89427 18C8.034 18 9.09818 17.6707 10 17.1005",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 9C13.0191 7.2066 14.924 6 17.1057 6C20.361 6 23 8.68629 23 12C23 15.3137 20.361 18 17.1057 18C14.924 18 13.0191 16.7934 12 15",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 12H19M19 12L17 10M19 12L17 14",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMigrate;
